import { render, staticRenderFns } from "./CustomerOtherList.vue?vue&type=template&id=ab8619a8&scoped=true"
import script from "./CustomerOtherList.vue?vue&type=script&lang=js"
export * from "./CustomerOtherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8619a8",
  null
  
)

export default component.exports